export default {
  items: [
    {
      title: true,
      name: "Type of Implant"
    },
    {
      name: "All types",
      url: "/nore/map-all",
      icon: "icon-map"
    },
    {
      name: "Ankle",
      url: "/nore/map-Ankle",
      icon: "icon-map"
    },
    {
      name: "Hip",
      url: "/nore/map-Hip",
      icon: "icon-map"
    },
    {
      name: "Knee",
      url: "/nore/map-Knee",
      icon: "icon-map"
    },
    {
      name: "Shoulder",
      url: "/nore/map-Shoulder",
      icon: "icon-map"
    }
  ]
};
